import * as $ from 'jquery';
import * as React from 'react';
import './../../js/select2.min.js';

interface Props extends React.SelectHTMLAttributes<any> {
    children?: React.ReactNode,
}

export default class SalesPersonSelect extends React.Component<Props, {}> {
    private select: HTMLSelectElement | null;

    constructor(props: Props) {
        super(props);

        this.select = null;
    }

    public render() {
        let { className, children, ...rest } = this.props;
        return <select className={"form-control select2-single " + className} {...rest} ref={x => this.select = x}>
            {children}
        </select>;
    }

    public componentDidMount() {
        $(this.select!).select2({
            dropdownCssClass: 'no-search'
        });
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/common/Select2.tsx